import { render } from "./InvoiceDetailsTable.vue?vue&type=template&id=80a80ce4&ts=true"
import script from "./InvoiceDetailsTable.vue?vue&type=script&lang=ts"
export * from "./InvoiceDetailsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__